<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">File Uploads</h2>
            <p class="tw-italic tw-text-gray-700">Upload any type of file.</p>
        </b-container>

        <hr />

        <b-container>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-file
                        id="file"
                        v-model="selectedFile"
                        :state="Boolean(selectedFile)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        size="lg"
                    ></b-form-file>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-input
                        v-model="title"
                        placeholder="Enter Document Title"
                        size="lg"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-select v-if="inMyGroups(['SAE Report Uploader'])"
                        v-model="category"
                        :options="SAEcategoryOptions"
                        size="lg"
                        placeholder="Select Category"
                    ></b-form-select>
                    <b-form-select v-else
                        v-model="category"
                        :options="categoryOptions"
                        size="lg"
                        placeholder="Select Category"
                    ></b-form-select>
                </b-col>
            </b-row>
            <b-row v-if="sae_selected">
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-select
                        v-model="sae_case"
                        :options="saes"
                        size="lg"
                        placeholder="Select Serious Adverse Event"
                    ></b-form-select>
                </b-col>
            </b-row>
            <!-- <b-row v-else> -->
            <b-row> <!-- this checkbox should always be here -->    
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-checkbox
                        id="is-private"
                        v-model="isPrivate"
                        name="is-private"
                        value="1"
                        unchecked-value=""
                        size="lg"
                    >
                        Only I can view this document! (Not Public)
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-button
                        @click="onUpload()"
                        variant="success"
                        size="lg"
                        block
                        :disabled="uploading"
                    >
                        Upload
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <hr />

        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input
                        v-model="search.title"
                        placeholder="Search Title"
                        size="lg"
                        @keyup="find()"
                    ></b-form-input>
                </b-col>
                <b-col>
                    <!-- <b-form-select
                        v-model="search.category"
                        :options="categoryOptions"
                        size="lg"
                        @change="find()"
                    >
                        <template #first>
                            <b-form-select-option value="">
                                -- Select Category --
                            </b-form-select-option>
                        </template>
                    </b-form-select> -->
                    <b-form-select v-if="inMyGroups([
                        'SAE Report Uploader',
                        'fhiClinical',
                        'DSMB'
                    ])"
                        v-model="search.category"
                        :options="SAEcategoryOptions"
                        size="lg"
                        @change="find()"
                        placeholder="Select Category"
                    ></b-form-select>
                    <b-form-select v-else
                        v-model="search.category"
                        :options="categoryOptions"
                        size="lg"
                        @change="find()"
                        placeholder="Select Category"
                    ></b-form-select>
                </b-col>
            </b-row>
        </b-container>

        <hr>

        <b-table
            striped
            borderless
            :fields="fields"
            :items="uploads"
            class="table-sm tw-text-sm"
        >
            <template v-slot:cell(user)="data">
                {{ data.value.name ? data.value.name : data.value.email }}
            </template>
            <template v-slot:cell(download)="data">
                <i
                    class="fas fa-download tw-cursor-pointer"
                    @click="download(data.item)"
                ></i>
            </template>
            <template v-slot:cell(delete)="data">
                <i
                    class="fas fa-trash tw-cursor-pointer"
                    @click="remove(data.item.id)"
                ></i>
            </template>
            <template v-slot:cell(is_private)="data">
                <i class="fas fa-check" v-if="!data.value"></i>
            </template>
        </b-table>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import { mapGetters } from "vuex";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    data() {
        return {
            baseUrl: `/kenya/uploads/`,
            selectedFile: null,
            title: "",
            category: "",
            isPrivate: "",
            categoryOptions: [
                { value: "", text: "-- Select Category --" },
                { value: "Document", text: "Document" },
                { value: "Monitoring Report", text: "Monitoring Report" },
                { value: "Protocol Deviation", text: "Protocol Deviation" },
            ],
            SAEcategoryOptions: [
                { value: "", text: "-- Select Category --" },
                { value: "Document", text: "Document" },
                { value: "Harm Report", text: "Harm Report" },
                { value: "Monitoring Report", text: "Monitoring Report" },
                { value: "Protocol Deviation", text: "Protocol Deviation" },
                { value: "SAE Report", text: "SAE Report" },
                { value: "SAE Followup Report", text: "SAE Followup Report"}
            ],
            fields: [
                "title",
                { key: "upload", label: "File" },
                { key: "is_private", label: "Public" },
                "category",
                "user",
                "download",
                "delete",
            ],
            uploads: [],
            uploading: false,
            // search: {},
            search: {
                category: ""  // set the inital value so that the drop-down will display "-- Select Category --"
            },
            saes: [],
            sae_selected: false,
            sae_case: null,
        };
    },
    computed: {
        ...mapGetters("user", ['inMyGroups']),
    },
    watch: {
        category: function(new_val, old_val){
            if(new_val == 'SAE Report' || new_val == 'SAE Followup Report'){
                this.sae_selected = true;
            }
        }
    },
    created() {
        this.find();
    },
    mounted() {
        let that = this;
        HTTP.get('/kenya/adverse_events/get_sae_list')
                .then((response) => {
                   _.each(response.data, function(sae){
                       let item = {
                           value: sae.id,
                           text: sae.ae_sae_id
                       }
                       that.saes.push(item);
                   });
                   if(response.data.length > 0){
                       that.sae_case = that.saes[0].value;
                   }
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
    },
    methods: {
        find() {
            const that = this;
            HTTP.get(that.baseUrl, { params: { ...that.search } })
                .then((response) => {
                    that.uploads = response.data;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        download(item) {
            const that = this;
            const d = new Date();
            let time = d.getTime();

            let downloadUrl = `${that.baseUrl}${item.id}?rand=${time}`;
            HTTP.get(downloadUrl, { responseType: "arraybuffer" })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", item.upload);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        remove(id) {
            const that = this;
            let deleteUrl = `${that.baseUrl}${id}`;
            HTTP.delete(deleteUrl)
                .then(() => {
                    that.uploads = _.filter(that.uploads, function (o) {
                        return o.id !== id;
                    });
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        onFileSelected: function (event) {
            this.selectedFile = event.target.files[0];
        },
        onUpload: function () {
            const that = this;
            if (!that.selectedFile) {
                return that.$bvModal.msgBoxOk("Please select a file!", {
                    title: "File Error",
                    okVariant: "danger",
                    centered: true,
                });
            }

            if (!that.title.trim()) {
                return that.$bvModal.msgBoxOk("Please select a title!", {
                    title: "Title Error",
                    okVariant: "danger",
                    centered: true,
                });
            }

            if (!that.category.trim()) {
                return that.$bvModal.msgBoxOk("Please select a category!", {
                    title: "Category Error",
                    okVariant: "danger",
                    centered: true,
                });
            }

            that.uploading = true;

            const fd = new FormData();
            fd.append("file", that.selectedFile, that.selectedFile.name);
            fd.append("title", that.title);

            // // force private if category is an SAE Report
            // if(that.category == 'SAE Report' || that.category == 'SAE Followup Report'){
            //     fd.append("is_private", true);
            // }
            // else{
            //     fd.append("is_private", that.isPrivate);
            // }
            fd.append("is_private", that.isPrivate);  // selecting an SAE category no longer always sets to private

            fd.append("category", that.category);
            fd.append("sae_case_id", that.sae_case);

            HTTP.post(that.baseUrl, fd)
                .then(() => {
                    that.selectedFile = null;
                    that.$notify({
                        text: "File successfully uploaded!",
                        duration: 10000,
                        type: "success",
                    });

                    that.selectedFile = null;
                    that.title = "";
                    that.category = "";
                    that.isPrivate = false;
                    that.sae_case = null;
                    that.sae_selected = false;

                    that.find();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                })
                .then(() => {
                    that.uploading = false;
                });
        },
    },
};
</script>
